import { GameTable } from '../game-table';
import { TableEvents } from '../table-events.enum';
import { TableEventInfo } from './table-event-info';

export class DealHoleCards extends TableEventInfo {
    getEventType(): TableEvents {
        return TableEvents.DEALING_HOLE_CARDS;
    }

    next(gameTable: GameTable): void {}

    prev(gameTable: GameTable): void {}
}
